<template>
  <div class="content">
    <Title>Settings</Title>

    <div class="columns">
      <div class="column is-6-desktop">
        <h2 class="h2 is-size-6">Main</h2>
        <template v-for="key of main">
          <CheckboxText
            :key="key"
            v-if="settings && settings.main"
            class="margin-bottom-10"
            :checked="settings.main[key]"
            @click="settings.main[key] = !settings.main[key]"
            >{{ key }}</CheckboxText
          >
        </template>

        <div class="margin-top-2">
          <button
            class="button is-primary is-small"
            :class="{ 'is-loading': mainLoading }"
            @click="save('main', settings.main)"
          >
            Save
          </button>
        </div>

        <div class=" margin-top-3">
          <h2 class="h2 is-size-6">E-mail</h2>
        </div>

        <BForm :elements="form" @valid="form.valid = $event"></BForm>

        <CheckboxText
          v-if="settings && settings.mail"
          class="margin-bottom-10 margin-top-10 "
          :checked="settings.mail.secure"
          @click="setProp('secure', !settings.mail.secure)"
          >Secure</CheckboxText
        >

        <CheckboxText
          v-if="settings && settings.mail"
          class="margin-bottom-10"
          :checked="settings.mail.requireTLS"
          @click="setProp('requireTLS', !settings.mail.requireTLS)"
          >Require TLS</CheckboxText
        >

        <div v-if="!mailVerified" class="margin-top-2">
          <button
            class="button is-info is-small"
            :class="{ 'is-loading': mailLoading }"
            :disabled="mailLoading || !form.valid"
            @click="testMail()"
          >
            Send test e-mail
          </button>
        </div>

        <article v-if="errorMessage" class="message is-danger margin-top-2">
          <div class="message-header">
            <span>Failed to send e-mail</span>
          </div>
          <div class="message-body">
            <p>{{ errorMessage }}</p>
          </div>
        </article>

        <div v-if="mailVerified" class="margin-top-2">
          <button
            class="button is-small is-default "
            @click="
              setDisable(false);
              mailVerified = false;
            "
          >
            Unlock form
          </button>
        </div>

        <div v-if="mailVerified" class="margin-top-2">
          <button
            class="button is-primary is-small"
            :class="{ 'is-loading': mailLoading }"
            @click="save('mail', getMailValues())"
          >
            Save
          </button>
        </div>

        <div class=" margin-top-3">
          <h2 class="h2 is-size-6">License</h2>
        </div>

        <BForm :elements="form2" @valid="form.valid = $event"></BForm>

        <div class="margin-top-2">
          <button
            class="button is-primary is-small"
            :class="{ 'is-loading': licenseLoading }"
            @click="save('license', getLicenseValue())"
          >
            Save
          </button>
        </div>
      </div>
    </div>

    <!-- <Confirm
        v-if="selected && showDelete"
        v-model="showDelete"
        @hide="selected = null"
        @confirmed="remove(selected)"
      >
        You are about to remove the global admin role from the user
        {{ selected.user.mail }}.
      </Confirm> -->
  </div>
</template>

<script>
import { postApi } from "@/utils/http";

export default {
  components: {
    Title: () => import("@/components/singles/Title.vue"),
    Confirm: () => import("@/components/main/Confirm.vue"),
    BForm: () => import("@/components/singles/BForm/component.vue"),
    CheckboxText: () => import("@/components/singles/CheckboxText.vue"),
  },
  data() {
    return {
      settings: null,
      main: [],
      mailLoading: false,
      mainLoading: false,
      licenseLoading: false,
      mailVerified: false,
      errorMessage: null,
      form2: {
        valid: false,
        areas: [
          {
            label: "Deployify license - text from license.json",
            focus: false,
            name: "license",
            type: "text",
            validation: "",
            value: "",
            disabled: false,
          },
        ],
      },
      form: {
        valid: false,
        areas: [
          {
            label: "DKIM - private key",
            name: "privateKey",
            type: "text",
            validation: "",
            value: "",
            disabled: false,
          },
        ],
        inputs: [
          {
            label: "Host",
            focus: true,
            name: "host",
            type: "text",
            validation: "required",
            value: "",
            disabled: false,
          },
          {
            label: "Port",
            name: "port",
            type: "number",
            validation: "required",
            value: "",
            disabled: false,
          },
          {
            label: "From address",
            name: "from",
            type: "text",
            validation: "required",
            value: "",
            disabled: false,
          },
          {
            label: "Username",
            name: "user",
            type: "text",
            validation: "",
            value: "",
            disabled: false,
          },
          {
            label: "Password",
            icon: "mdi-lock",
            name: "pass",
            type: "password",
            validation: "",
            value: "",
            disabled: false,
          },
          {
            label: "To address - for testing",
            name: "Test",
            type: "email",
            validation: "required|email",
            value: "",
            disabled: false,
          },
          {
            label: "DKIM - domain name",
            focus: true,
            name: "domainName",
            type: "text",
            validation: "",
            value: "",
            disabled: false,
          },
          {
            label: "DKIM - key selector",
            focus: true,
            name: "keySelector",
            type: "text",
            validation: "",
            value: "",
            disabled: false,
          },
        ],
      },
    };
  },
  async created() {
    await this.get();
    this.firstLoadDone = true;
  },
  methods: {
    setProp(prop, val) {
      this.$set(this.settings.mail, prop, val);
    },
    async testMail() {
      try {
        this.errorMessage = null;
        this.mailLoading = true;
        this.mailSaving = false;
        const mail = this.getMailValues();
        const res = await postApi(`mail/test`, { mail });
        this.mailVerified = true;
        this.errorMessage = null;
        this.setDisable(true);
        this.$helpers.notify(
          "Success",
          `The test e-mail is sent. Remember to save the settings.`,
          "success",
          -1
        );
      } catch (err) {
        this.mailVerified = false;
        if (err.response) this.errorMessage = err.response.data;
        else this.errorMessage = "Unknow error.";
        this.setDisable(false);
      }
      this.mailLoading = false;
    },
    async get() {
      const res = await postApi("get/settings");

      const settings = res;
      if (res) {
        delete settings.main.domainName;
        this.settings = settings;
        this.main = Object.keys(settings.main);
        if (settings.mail) this.setMailValues(settings.mail);
        if (settings.license) this.setLicenseValue(settings.license);
      }
    },

    async save(what, obj) {
      try {
        if (what === "mail") this.mailLoading = true;
        if (what === "main") this.mainLoading = true;
        if (what === "license") {
          this.licenseLoading = true;
          try {
            JSON.parse(obj.license);
          } catch (err) {
            this.$helpers.notify(
              "Invalid format",
              "The license is not a valid format.",
              "warning",
              5000
            );
            this.licenseLoading = false;
            return;
          }
        } else this.mainLoading = true;
        const res = await postApi(`set/settings/${what}`, { settings: obj });

        this.$helpers.notify(
          "Success",
          `${what} settings was saved. ${
            what === "mail" && !this.settings.main.emailEnabled
              ? 'Remember to check the "mailEnabled" above (and save) to use the features related to e-mail.'
              : ""
          } `,
          "success",
          10000
        );

        if (what === "main") this.$store.dispatch("settings/fetchServer");
      } catch (err) {
        console.log(err);

        this.$helpers.notify("Error", "Could not save settings.", "danger", -1);
      }

      this.mailLoading = false;
      this.mainLoading = false;
      this.licenseLoading = false;
    },

    setMailValues(mail) {
      this.form.inputs[0].value = mail.host || "";
      this.form.inputs[1].value = mail.port;
      this.form.inputs[2].value = mail.from || "";
      this.form.inputs[3].value = mail.user || "";
      this.form.inputs[4].value = mail.pass || "";
      this.form.inputs[5].value = mail.to || "";
      this.form.inputs[6].value = mail.domainName || "";
      this.form.inputs[7].value = mail.keySelector || "";
      this.form.areas[0].value = mail.privateKey || "";
    },

    getMailValues() {
      try {
        const mail = { auth: {} };
        mail.host = this.form.inputs[0].value.trim();
        mail.port = this.form.inputs[1].value;
        mail.from = this.form.inputs[2].value.trim();
        mail.user = this.form.inputs[3].value.trim();
        mail.pass = this.form.inputs[4].value;
        mail.to = this.form.inputs[5].value.trim();
        mail.domainName = this.form.inputs[6].value.trim();
        mail.keySelector = this.form.inputs[7].value.trim();

        mail.privateKey = this.form.areas[0].value.trim();
        mail.requireTLS = this.settings.mail.requireTLS;
        mail.secure = this.settings.mail.secure;

        return mail;
      } catch (error) {
        console.error(error);
      }

      return {};
    },

    getLicenseValue() {
      try {
        return { license: this.form2.areas[0].value.trim() };
      } catch (error) {
        console.error(error);
      }
      return {};
    },
    setLicenseValue(license) {
      this.form2.areas[0].value = license;
    },
    setDisable(disabled) {
      this.form.inputs.map(
        (x, index) => (this.form.inputs[index].disabled = disabled)
      );

      this.form.areas.map(
        (x, index) => (this.form.areas[index].disabled = disabled)
      );
    },
  },
};
</script>
